<template>
    <div>
        <h2 class="mb-4">
            <b>{{ $t('serviceDetail.qualityGuarantee') }}</b>
        </h2>
        <div class="row service-detail__content__card">
            <div class="col-md-12">
                <div class="thumb">
                    <img class="service-detail__content__card__image" :src="data.thumbnail" :alt="data.name" />
                </div>
                <div class="title">
                    <h3>
                        <b>{{ data.name }}</b>
                    </h3>
                    <p>{{ data.position }}</p>
                </div>
                <div class="desc" v-html="data.description"></div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        benefits: {
            type: Array,
            required: true,
        },
    },
}
</script>
<style lang="scss" scoped>
.service-detail__content__card {
    margin-bottom: 60px;

    h2 {
        margin-bottom: 20px;
    }
}
</style>
